import { BatchCosignItem } from "@/features/cosignature/types";
import { Button2 } from "@/ui2/atoms/Button";

import { useCosignatureModal } from "../CosignatureModalProvider";

export function BatchControls({ items }: { items: BatchCosignItem[] }) {
  const { openBatchModal } = useCosignatureModal();

  return (
    <div className="tw:flex tw:gap-4 tw:md:ml-auto">
      <Button2
        onPress={() => openBatchModal({ action: "reject", items })}
        variant="destructive-primary"
      >
        Reject
      </Button2>

      <Button2 onPress={() => openBatchModal({ action: "cosign", items })} variant="primary">
        Approve
      </Button2>
    </div>
  );
}
